import throttle from 'lodash.throttle';
import { type ComponentType, memo, useMemo } from 'react';
import type { SliderHelpers } from '../..';
import { SlideGridContainer, type SliderChunk } from '../SlideGridContainer';
import { ScSlider } from './styled';

interface ISlider<T> {
  currentSlideIndex: number;
  handleNativeScroll: (event: React.UIEvent<HTMLDivElement>) => void;
  slidesPerView?: number;
  sliderRef: React.RefObject<HTMLDivElement>;
  slidesChunk?: SliderChunk<T>[];
  itemComponent: ComponentType<T>;
  sliderHelpers: SliderHelpers;
}

export const SliderComponent = <T,>({
  sliderRef,
  currentSlideIndex,
  handleNativeScroll,
  slidesPerView,
  slidesChunk,
  itemComponent,
  sliderHelpers,
}: ISlider<T>) => {
  const throttledScroll = useMemo(
    () => throttle(handleNativeScroll, 100),
    [handleNativeScroll]
  );

  return (
    <ScSlider
      className="slider"
      onScroll={throttledScroll}
      ref={sliderRef}
      slidesPerView={slidesPerView}
    >
      {slidesChunk?.map((slideProps, index) => (
        <div
          className={`snap-item ${
            index === currentSlideIndex ? 'current-slide' : ''
          }`}
          data-testid={`slider-slide-${index}`}
          key={index}
        >
          <SlideGridContainer
            {...slideProps}
            itemComponent={itemComponent}
            key={index}
            sliderHelpers={sliderHelpers}
          />
        </div>
      ))}
    </ScSlider>
  );
};

export const Slider = memo(SliderComponent) as typeof SliderComponent;
